import request from './request'
const activity = 'ACTIVITY-SERVE'
// 活动列表
export const http = {
  // 活动下发单跳信息查询
  findById: (data) => {
    return request({
      url: activity + '/activityplan/findById',
      method: 'post',
      data
    })
  },
  // 活动删除
  deleteActplan: (data) => {
    return request({
      url: activity + '/activityplan/deleteActplan',
      method: 'post',
      data
    })
  },
  // 活动导出
  exportActivity: (data) => {
    return request({
      url: activity + '/activityplan/exportActivity',
      method: 'post',
      responseType: 'blob',
      timeout: 600000,
      data
    })
  },
  // 活动下发经销商查询
  dealerFindList: (data) => {
    return request({
      url: activity + '/actplantarget-dealer/findList',
      method: 'post',
      data
    })
  },
  // 活动下发经销商删除
  deleteBatchActplanDealer: (data) => {
    return request({
      url: activity + '/actplantarget-dealer/deleteBatchActplanDealer',
      method: 'post',
      data
    })
  },
  // 提报列表查询
  findMarketactivityList: (data) => {
    return request({
      url: activity + '/marketactivity/findMarketactivityList',
      method: 'post',
      data
    })
  },
  // 提报列表导出
  OutExportMarketactivity: (data) => {
    return request({
      url: activity + '/marketactivity/exportMarketactivity',
      method: 'post',
      responseType: 'blob',
      data
    })
  },
  // 审核流程开启
  marketApproveStart: (data) => {
    return request({
      url: activity + '/activity-approve/marketApproveStart',
      method: 'post',
      data
    })
  },
  // 审核流程查询
  getApproveProcess: (data) => {
    return request({
      url: activity + '/activity-approve/getApproveProcess',
      method: 'post',
      data
    })
  },

  // 检查id是否可以审核
  findUserApproveMarketList: (data) => {
    return request({
      url: activity + '/activity-approve/findUserApproveMarketList',
      method: 'post',
      data
    })
  },
  // 查询 车列表
  CarfindList: (data) => {
    return request({
      url: activity + '/strain-collectqty/findList',
      method: 'post',
      data
    })
  },
  // 批量删除车
  deleteStoreActivityCar: (data) => {
    return request({
      url: activity + '/strain-collectqty/deleteStoreActivityCar',
      method: 'post',
      data
    })
  },
  // 审核
  marketApproveExecute: (data) => {
    return request({
      url: activity + '/activity-approve/marketApproveExecute',
      method: 'post',
      data
    })
  },
  // 审核历史
  findHistTasks: (data) => {
    return request({
      url: activity + '/activity-approve/findHistTasks',
      method: 'post',
      data
    })
  },
  // 经销商导出
  OutExport: (data) => {
    return request({
      url: activity + '/actplantarget-dealer/export',
      method: 'post',
      data,
      responseType: 'blob'
    })
  },
  // 经销商导入
  importExcel: (data) => {
    return request({
      url: activity + '/actplantarget-dealer/importExcel',
      method: 'post',
      data
    })
  },
  // 经销商添加
  addBatchActplanDealer: (data) => {
    return request({
      url: activity + '/actplantarget-dealer/addBatchActplanDealer',
      method: 'post',
      data
    })
  },

  // 删除提报
  deleteMarket: (data) => {
    return request({
      url: activity + '/marketactivity/deleteMarket',
      method: 'post',
      data
    })
  },
  // 删除核销信息
  deleteWriteoff: (data) => {
    return request({
      url: activity + '/marketact-writeoff/deleteWriteoff',
      method: 'post',
      data
    })
  },

  // 新增提报/修改（核销提交）
  saveMarketactWWriteoff: (data) => {
    return request({
      url: activity + '/marketact-writeoff/saveMarketactWWriteoff',
      method: 'post',
      data
    })
  },
  // 核销流程开启
  marketApproveWriteoffStart: (data) => {
    return request({
      url: activity + '/activity-approve/marketApproveWriteoffStart',
      method: 'post',
      data
    })
  },
  // 查询核销id
  findList: (data) => {
    return request({
      url: activity + '/marketact-writeoff/findList',
      method: 'post',
      data
    })
  },
  // 核销审核
  marketApproveWriteoffExecute: (data) => {
    return request({
      url: activity + '/activity-approve/marketApproveWriteoffExecute',
      method: 'post',
      data
    })
  },
  // 查询核销列表
  findList2: (data) => {
    return request({
      url: activity + '/marketact-writeoff/findList2',
      method: 'post',
      data
    })
  },

  // 历史核销信息
  findWriteoffHistTasks: (data) => {
    return request({
      url: activity + '/activity-approve/findWriteoffHistTasks',
      method: 'post',
      data
    })
  },

  // 历史核销信息
  GetFindListDepartment: (data) => {
    return request({
      url: activity + '/department/findList',
      method: 'post',
      data
    })
  },
  // 测试链接
  test1: (data) => {
    return request({
      url: activity + '/file/upload',
      method: 'post',
      data
    })
  },
  // 文件下载
  download: (params) => {
    return request({
      url: activity + '/file/download',
      method: 'get',
      responseType: 'blob',
      params
    })
  }
}
